module.exports = __webpack_public_path__ + "static/img/tubaina-zero.732421d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/tubaina-zero.png
// module id = VBTu
// module chunks = 0